module.exports = __webpack_public_path__ + "images/backgrounds/cosmos/medium.6df19fc8731536cdce68.jpg";